const englishToPersianMap: any = {
	0: '۰',
	1: '۱',
	2: '۲',
	3: '۳',
	4: '۴',
	5: '۵',
	6: '۶',
	7: '۷',
	8: '۸',
	9: '۹',
};

const persianToEnglishMap: any = {
	'۰': 0,
	'٠': 0,
	'۱': 1,
	'١': 1,
	'۲': 2,
	'٢': 2,
	'۳': 3,
	'٣': 3,
	'۴': 4,
	'٤': 4,
	'۵': 5,
	'٥': 5,
	'۶': 6,
	'٦': 6,
	'۷': 7,
	'٧': 7,
	'۸': 8,
	'٨': 8,
	'۹': 9,
	'٩': 9,
};

const toPersianNumbers = (num: string | number): string => {
	if (!num && typeof num !== 'number') return num;

	return num
		.toString()
		.split('')
		.map((i) => (/[0-9]/.test(i) ? englishToPersianMap[i] : i))
		.join('');
};

const toEnglishNumbers = (num: string | number): string => {
	if (!num && typeof num !== 'number') return num;

	return num
		.toString()
		.split('')
		.map((i) =>
			/[\u0660-\u0669]/.test(i) || /[۰-۹]/.test(i)
				? persianToEnglishMap[i]
				: i,
		)
		.join('');
};

export { toPersianNumbers, toEnglishNumbers };
